import {
    buildListParams,
    getListData,
    getTotalRecords,
    handleListDeleteIconMouseEnter,
    handleListIconMouseEnter,
    handleListIconMouseLeave,
    listStyles,
    loadStoredJson,
    removeStoredKeys,
    saveStoredValue
} from 'lib/listUtils';
import {
    Button,
    Card,
    CardContent,
    FormControl,
    FormLabel,
    Input,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip
} from '@material-ui/core';
import {
    BackspaceOutlined as BackspaceOutlinedIcon,
    DeleteForeverOutlined as DeleteForeverOutlinedIcon,
    EditTwoTone as EditTwoToneIcon,
    Search as SearchIcon,
    VisibilityOutlined as VisibilityOutlinedIcon
} from '@material-ui/icons';
import api from 'services/api';
import { ANAO, ASIM } from 'consts';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { formatData } from 'lib/functions';
import PerfectScrollbar from 'react-perfect-scrollbar';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import DeleteConfirmationModal from 'components/DeleteConfirmationModal/DeleteConfirmationModal';

class AbastecimentoList extends Component {
    state = {
        searchFilter: loadStoredJson('abastecimentoSearchFilter', {
            nroveiculo: '',
            veiculoproprio: 'T',
            datainicial: '',
            datafinal: ''
        }),
        abastecimentos: [],
        open: false,
        openAlert: false,
        messageAlert: '',
        selectedId: null,
        selectedDesc: '',
        totalItems: 0,
        page: Number(sessionStorage.getItem('abastecimentoPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('abastecimentoRowsPerPage')) || 10
    };

    estilo = listStyles;

    handleIconMouseEnter = handleListIconMouseEnter;
    handleIconMouseLeave = handleListIconMouseLeave;
    handleDeleteIconMouseEnter = handleListDeleteIconMouseEnter;

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this.loadAbastecimentos();
    };

    /* Paginação */
    componentDidUpdate(prevProps, prevState) {
        const { searchFilter, page, rowsPerPage } = this.state;

        // persiste os filtros e a paginação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            saveStoredValue('abastecimentoSearchFilter', searchFilter);
        }

        if (prevState.page !== page) {
            saveStoredValue('abastecimentoPage', page);
        }

        if (prevState.rowsPerPage !== rowsPerPage) {
            saveStoredValue('abastecimentoRowsPerPage', rowsPerPage);
        }
    };

    /* Limpa os filtros e a paginação ao sair da tela */
    componentWillUnmount() {
        removeStoredKeys([
            'abastecimentoSearchFilter',
            'abastecimentoPage',
            'abastecimentoRowsPerPage'
        ]);
    };

    /* Carrega os abastecimentos */
    loadAbastecimentos = async () => {
        const { page, rowsPerPage, searchFilter } = this.state;
        const { nroveiculo, veiculoproprio, datainicial, datafinal } = searchFilter;

        const params = buildListParams({
            page,
            rowsPerPage,
            filters: [
                {
                    field: 'NROVEICULO',
                    value: nroveiculo,
                    operator: '_like_'
                },
                {
                    field: 'VEICULOPROPRIO',
                    value: veiculoproprio
                },
                {
                    field: 'DATAINICIAL',
                    value: datainicial
                },
                {
                    field: 'DATAFINAL',
                    value: datafinal
                }
            ]
        });

        try {
            const response = await api.get('/abastecimento' + params);

            this.setState({
                abastecimentos: getListData(response),
                totalItems: getTotalRecords(response)
            });
        } catch (error) {
            console.error('Erro ao carregar abastecimentos:', error);

            this.setState({
                abastecimentos: [],
                totalItems: 0
            });
        }
    };

    /* Muda a página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadAbastecimentos);
    };

    /* Muda a quantidade de retornos por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, this.loadAbastecimentos);
    };

    /* Deleta o abastecimento */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/abastecimento/${id}`);

            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadAbastecimentos();
            }
        } catch (error) {
            this.handleClose();

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao excluir abastecimento!'
            );
        }
    };

    /* Confirma a exclusão */
    handleConfirmDelete = () => {
        const { selectedId } = this.state;

        this.handleDelete(selectedId);
    };

    /* Abre a janela de confirmação para a exclusão */
    handleOpen = (codabastecimento, nroveiculo) => {
        this.setState({
            open: true,
            selectedId: codabastecimento,
            selectedDesc: nroveiculo
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de confirmação da exclusão */
    handleClose = () => {
        this.setState({
            open: false,
            selectedId: null,
            selectedDesc: ''
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { name, value } = event.target;

        const searchFilter = {
            ...this.state.searchFilter,
            [name]: (name === 'datainicial' || name === 'datafinal')
                ? value
                : (typeof value === 'string') ? value.toUpperCase() : value
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            nroveiculo: '',
            veiculoproprio: 'T',
            datainicial: '',
            datafinal: ''
        };

        this.setState({
            searchFilter,
            page: 0
        }, this.loadAbastecimentos);
    };

    render() {
        const {
            abastecimentos,
            messageAlert,
            open,
            openAlert,
            page,
            rowsPerPage,
            searchFilter,
            selectedDesc,
            selectedId,
            totalItems
        } = this.state;

        const {
            actionIcon,
            addButton,
            filterPaper,
            iconGroup
        } = this.estilo;

        return (
            <div style={this.estilo}>
                <Paper
                    hover
                    fullWidth
                    style={filterPaper}
                >
                    <Input
                        autoFocus
                        id="nroveiculo"
                        name="nroveiculo"
                        onChange={this.onChangeSearch}
                        placeholder="Veículo"
                        value={searchFilter.nroveiculo}
                        style={{
                            flex: '0 1 200px',
                            minWidth: 200
                        }}
                    />

                    <Select
                        id="veiculoproprio"
                        name="veiculoproprio"
                        value={searchFilter.veiculoproprio || 'T'}
                        onChange={this.onChangeSearch}
                        style={{
                            flex: '0 1 100px',
                            minWidth: 100,
                            textAlign: 'center'
                        }}
                    >
                        <MenuItem
                            value={ASIM}
                            style={{ justifyContent: 'center' }}
                        >
                            Próprios
                        </MenuItem>

                        <MenuItem
                            value={ANAO}
                            style={{ justifyContent: 'center' }}
                        >
                            Terceiros
                        </MenuItem>

                        <MenuItem
                            value="T"
                            style={{ justifyContent: 'center' }}
                        >
                            Todos
                        </MenuItem>
                    </Select>

                    <FormControl
                        component="fieldset"
                        style={{
                            padding: '6px 12px',
                            border: '1px solid #bdbdbd',
                            borderRadius: 12,
                            flex: '0 1 300px',
                            minWidth: 300,
                            justifyContent: 'center'
                        }}
                    >
                        <FormLabel
                            component="legend"
                            style={{
                                fontSize: 12,
                                padding: '0 4px',
                                color: '#616161'
                            }}
                        >
                            Período abastecimento
                        </FormLabel>

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8
                            }}
                        >
                            <Input
                                id="datainicial"
                                name="datainicial"
                                type="date"
                                value={searchFilter.datainicial || ''}
                                onChange={this.onChangeSearch}
                                style={{
                                    flex: '0 1 120px',
                                    minWidth: 120
                                }}
                            />

                            <span>a</span>

                            <Input
                                id="datafinal"
                                name="datafinal"
                                type="date"
                                value={searchFilter.datafinal || ''}
                                onChange={this.onChangeSearch}
                                style={{
                                    flex: '0 1 120px',
                                    minWidth: 120
                                }}
                            />
                        </div>
                    </FormControl>

                    <span style={iconGroup}>
                        <Tooltip title="Procurar">
                            <SearchIcon
                                onClick={this.loadAbastecimentos}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>

                        <Tooltip title="Limpar">
                            <BackspaceOutlinedIcon
                                onClick={this.limpaFiltros}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to="/frotas/abastecimento/novo"
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Código</TableCell>

                                            <TableCell align="center">Descrição</TableCell>

                                            <TableCell align="center">Data</TableCell>

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {abastecimentos.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={4}
                                                >
                                                    Nenhum abastecimento encontrado
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        {abastecimentos.map(abastecimento => (
                                            <TableRow
                                                hover
                                                key={abastecimento.codabastecimento}
                                            >
                                                <TableCell align="center">
                                                    {abastecimento.codabastecimento}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {abastecimento.nroveiculo}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {formatData(abastecimento.data)}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <span style={iconGroup}>
                                                        <Tooltip title="Editar">
                                                            <Link to={`/frotas/abastecimento/${abastecimento.codabastecimento}`}>
                                                                <EditTwoToneIcon
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Visualizar">
                                                            <Link to={`/frotas/abastecimento/${abastecimento.codabastecimento}/view`}>
                                                                <VisibilityOutlinedIcon
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Excluir">
                                                            <DeleteForeverOutlinedIcon
                                                                onMouseEnter={this.handleDeleteIconMouseEnter}
                                                                onMouseLeave={this.handleIconMouseLeave}
                                                                onClick={() => this.handleOpen(
                                                                    abastecimento.codabastecimento,
                                                                    abastecimento.nroveiculo
                                                                )}
                                                                style={actionIcon}
                                                            />
                                                        </Tooltip>
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>

                        <TablePagination
                            component="div"
                            count={totalItems}
                            page={page}
                            onPageChange={this.handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            rowsPerPageOptions={[10, 50, 100, 200]}
                            labelRowsPerPage="Registros por página"
                        />
                    </CardContent>
                </Card>

                <DeleteConfirmationModal
                    open={open}
                    itemId={selectedId}
                    message={`Confirma exclusão do abastecimento ${selectedDesc || ''} [${selectedId}]?`}
                    handleClose={this.handleClose}
                    handleDelete={this.handleConfirmDelete}
                />

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default AbastecimentoList;